export { FaroRoute } from './FaroRoute';
export { createReactRouterV4Options, createReactRouterV5Options, initializeReactRouterV4V5Instrumentation, } from './initialize';
export { setReactRouterV4V5SSRDependencies } from './routerDependencies';
//# sourceMappingURL=index.js.map